/**
 * Property-level translation table for opaque PMS rate-plan codes.
 *
 * Casablanca streams system-generated rate strings (`PMS_QCHC623G`, `PMS_W4JRNZDE`) on the OTA
 * feed. CX exports the readable designations from the hotel's Casablanca *Ratenmanagement* screen
 * and maintains them here, which gives staff readable board codes ("HP", "ÜF", "AI") on the arrival
 * lists and the floor plan without the hotel paying for the Casablanca POS API endpoint.
 */
export var PmsProvider;
(function (PmsProvider) {
    PmsProvider["CASABLANCA"] = "CASABLANCA";
})(PmsProvider || (PmsProvider = {}));
